
















































































import { Component, Vue } from 'vue-property-decorator';
import { ApiClient, apiClient } from '@/api/ApiClient';
import moment from 'moment';
import TickCross from '@/components/TickCross.vue';
import { download } from '@/utils/file';
import camelcase from 'camelcase';
import { dateRangeTodayUntilEnd } from '@/utils/helper';

@Component({
  components: {
    TickCross,
  },
})
export default class extends Vue {

  public get moment() {
    return moment;
  }

  // table filter
  public range: Date[] = dateRangeTodayUntilEnd();
  public customerId: number = null;
  public applicationId: number = null;
  public serviceTypeSmsId: number = null;
  public regionId: number = null;
  public vendorId: number = null;
  public state: string = null;
  public phone = '';
  public orderByColumn: string = null;
  public orderByOrder: string = null;

  public get stateSelect() {
    return this.communicationMessagesStates.map(p => ({
      label: p,
      value: p,
    }));
  }

  // table
  public isTableLoading = false;

  public pageSize = 20;
  public total = 0;
  public currentPage = 1;

  public data: any[] = [];
  public customers: any[] = [];
  public applications: any[] = [];
  public services: any[] = [];
  public get serviceTypeSmss() {
    const service = this.services.find(p => p.name === 'Sms') || {};
    return service.serviceTypeSmss;
  }
  public regions: any[] = [];
  public vendors: any[] = [];
  public communicationMessagesStates: any[] = [];

  // filter
  public get filteredApplications() {
    return this.applications
    .filter(p =>
      (!this.customerId || p.customer.id === this.customerId)
    );
  }

  public mounted() {
    this.loadData();
  }

  // filter events
  public async onFilterCustomerChange() {
    this.applicationId = null;
    await this.loadMessages();
  }

  // other events
  public async onClickExport() {
    const loading = this.$loading({});
    try {
      const [from, to] = this.range || [] as Date[];
      const response = await apiClient.communicationMessagesExport(this.getFilter());
      download(response);
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.close();
    }
  }

  // table events
  public async onPaginationChange() {
    await this.loadMessages();
    this.$scrollTo("#data-table");
  }

  // sort
  public async tableSortChange({ column, prop, order }) {
    if (prop && order) {
      this.orderByColumn = camelcase(prop.replace('.', '_'));
      this.orderByOrder = order.startsWith("asc") ? "ASC" : 'DESC';
    } else {
      this.orderByOrder = this.orderByColumn = null;
    }
    return this.loadMessages();
  }

  //
  private async loadData() {
    await Promise.all([
      this.loadMessages(),
      this.loadCustomers(),
      this.loadApplications(),
      this.loadServices(),
      this.loadRegions(),
      this.loadVendors(),
      this.loadCommunicationMessagesStates(),
    ]);
  }

  private async loadCustomers() {
    const { data } = await apiClient.customers({
      take: Number.MAX_SAFE_INTEGER,
    });
    this.customers = data.data;
  }

  private async loadApplications() {
    const { data } = await apiClient.applications({
      serviceId: 1,
      take: Number.MAX_SAFE_INTEGER,
    });
    this.applications = data.data;
  }

  private async loadRegions() {
    const { data } = await apiClient.regions();
    this.regions = data;
  }

  private async loadServices() {
    const { data } = await apiClient.services();
    this.services = data;
  }

  private async loadVendors() {
    const { data } = await apiClient.vendors();
    this.vendors = data;
  }

  private async loadCommunicationMessagesStates() {
    const { data } = await apiClient.communicationMessagesStates();
    this.communicationMessagesStates = data;
  }

  private async loadMessages() {
    this.isTableLoading = true;

    const { data } = await apiClient.communicationMessages(this.getFilter());

    this.total = data.count;
    this.data = data.data;
    this.isTableLoading = false;
  }

  private getFilter() {
    const range = this.range || [];

    return {
      take: this.pageSize,
      page: this.currentPage,

      orderByColumn: this.orderByColumn,
      orderByOrder: this.orderByOrder,

      customerId: this.customerId || undefined,
      applicationId: this.applicationId || undefined,
      regionId: this.regionId || undefined,
      vendorId: this.vendorId || undefined,
      serviceTypeSmsId: this.serviceTypeSmsId || undefined,

      state: this.state,
      phone: this.phone,

      from: range[0],
      to: range[1],
    };
  }

}
